import dayjs from 'dayjs';

export const formatStreamDate = (dateString: any): string => {
  return dayjs(dateString).format('ddd DD MMM [AT] hh:mm A');
};

// Format date for video details in format (D MMM YYYY) in local timezone -> 10 Dec 2025
export const formatVideoDetailsDate = (dateString: string): string => {
  if (!dateString || !dayjs(dateString).isValid()) {
    return dayjs().local().format('D MMM YYYY');
  }

  return dayjs(dateString).local().format('D MMM YYYY');
};

// Format date as short month + day -> "Jun 9". Returns the original string when invalid.
export const formatShortDate = (dateString: string): string => {
  const date = dayjs(dateString);
  if (!date.isValid()) {
    return dateString;
  }
  return date.format('MMM D');
};
